module.exports = __webpack_public_path__ + "static/media/crm-disabled.06f709cb.png";